export interface Mes {
    mes: number;
    abreviacao: string;
    nome: string;
}

export const janeiro: Mes = {mes: 1, abreviacao: 'JAN', nome: 'Janeiro'};
export const fevereiro: Mes = {mes: 2, abreviacao: 'FEV', nome: 'Fevereiro'};
export const marco: Mes = {mes: 3, abreviacao: 'MAR', nome: 'Março'};
export const abril: Mes = {mes: 4, abreviacao: 'ABR', nome: 'Abril'};
export const maio: Mes = {mes: 5, abreviacao: 'MAI', nome: 'Maio'};
export const junho: Mes = {mes: 6, abreviacao: 'JUN', nome: 'Junho'};
export const julho: Mes = {mes: 7, abreviacao: 'JUL', nome: 'Julho'};
export const agosto: Mes = {mes: 8, abreviacao: 'AGO', nome: 'Agosto'};
export const setembro: Mes = {mes: 9, abreviacao: 'SET', nome: 'Setembro'};
export const outubro: Mes = {mes: 10, abreviacao: 'OUT', nome: 'Outubro'};
export const novembro: Mes = {mes: 11, abreviacao: 'NOV', nome: 'Novembro'};
export const dezembro: Mes = {mes: 12, abreviacao: 'DEZ', nome: 'Dezembro'};

export const meses: Mes[] = [
    janeiro,
    fevereiro,
    marco,
    abril,
    maio,
    junho,
    julho,
    agosto,
    setembro,
    outubro,
    novembro,
    dezembro
];
